import React, {PureComponent} from "react"
import moment from "moment"
import {BarChart, Bar, CartesianGrid, ResponsiveContainer, XAxis, YAxis} from "recharts"

import Pill from "@irati/ui/src/Pill"
import {perkbox} from "@irati/ui/src/global/colors"
import {FormattedMessage} from "@irati/utils/lang"
import {PerksMetricsByTenant} from "@irati/types"

import {StyledHr} from "../../../../containers/Reporting/styled"
import {TitleWrapper, StyledHeader, HeaderWrapper} from "../../styled/styled"

const REDEMPTION_WEEKS = 12
interface Props {
  perksAndPerksGoMetrics: PerksMetricsByTenant
}

class PerksActivityChart extends PureComponent<Props> {
  getPerksActivity = (numberOfWeeks: number) => {
    const redemptionDates = []
    /* Getting the  dates of last 12 mondays */
    const firstMonday = moment()
      .isoWeekday(1)
      .subtract(numberOfWeeks, "weeks")
    for (let i = 0; i < numberOfWeeks; i++) {
      const date = `w/c ${firstMonday.add(1, "weeks").format("Do MMM")}`
      redemptionDates.push(date)
    }
    return redemptionDates
  }

  getRedemptionData = () => {
    const {perksAndPerksGoMetrics} = this.props
    const {redemptions_12_weeks} = perksAndPerksGoMetrics
    const redemptionsDates = this.getPerksActivity(REDEMPTION_WEEKS) || []
    return redemptionsDates.map((redemptionsDate, index) => {
      return {
        date: redemptionsDate,
        count: redemptions_12_weeks[index]
      }
    })
  }

  getDaysDifference = () => {
    const {perksAndPerksGoMetrics} = this.props
    const {last_updated_date} = perksAndPerksGoMetrics
    const lastUpdatedDate = moment(last_updated_date).startOf("day")
    const today = moment().startOf("day")
    const relativeDays = today.diff(lastUpdatedDate, "days")
    return relativeDays
  }

  render() {
    const {perksAndPerksGoMetrics} = this.props
    const {redemptions_12_weeks} = perksAndPerksGoMetrics
    const redemptionData = redemptions_12_weeks && this.getRedemptionData()
    const lastUpdatedDay = this.getDaysDifference()
    return (
      <>
        <HeaderWrapper>
          <StyledHeader>
            <FormattedMessage id="admin.reporting.perks" />
          </StyledHeader>
          <Pill text={<FormattedMessage id="admin.reporting.perksActivity.lastUpdatedDate" values={{lastUpdatedDay}} />} />
        </HeaderWrapper>
        <StyledHr />
        <TitleWrapper>
          <FormattedMessage id="admin.reporting.perksActivityChart.title" />
        </TitleWrapper>
        <ResponsiveContainer width="100%" height={250}>
          <BarChart width={1000} height={250} data={redemptionData}>
            <CartesianGrid vertical={false} />
            <XAxis dataKey="date" tickLine={false} fontFamily="Lato, sans-serif" fontSize="10px" interval={0} axisLine={false} />
            <YAxis dataKey="count" tickLine={false} tickCount={5} fontFamily="Lato, sans-serif" fontSize="10px" />
            <Bar dataKey="count" barSize={50} fill={perkbox.blue} />
          </BarChart>
        </ResponsiveContainer>
      </>
    )
  }
}

export default PerksActivityChart
